import React from 'react';
import messages from '../messages';
import Row from './Row';

const PostTable = ({
  posts,
  selected,
  setSelected,
  onDoubleClick,
  onDelete,
  onRevert,
  onChatClick,
  handleContextMenu,
  contextData,
}) => {
  const allPosts = posts.filter((p) => !p.isSpecial);

  const renderBody = () => (
    <tbody>
      {allPosts.map((post) => (
        <React.Fragment key={post._id}>
          <Row
            onEnter={() => {
              onDoubleClick(post);
            }}
            selected={selected}
            post={post}
            onDelete={onDelete}
            onRevert={onRevert}
            setSelected={setSelected}
            onUpdate={() => {}}
            onChatClick={onChatClick}
            handleContextMenu={handleContextMenu}
            contextData={contextData}
          />
        </React.Fragment>
      ))}
    </tbody>
  );

  const renderHeader = () => (
    <thead>
      <tr>
        <th style={{minWidth: 16}} className="p-0"></th>
        <th style={{minWidth: 400}} className="post-img bg-white">
          {messages.name}
        </th>
        <th style={{minWidth: 120}} className="bg-white text-center">
          {messages.folderId}
        </th>
        <th style={{minWidth: 100}} className="text-center text-uppercase">
          {messages.quantity}
        </th>
        <th style={{minWidth: 116}} className="bg-white text-center">
          {messages.modified}
          <img src="images/icon-sort.svg" className="ml-2" alt="" />
        </th>
        <th style={{minWidth: 100}} className="bg-white text-center">
          {messages.volume}
        </th>
      </tr>
    </thead>
  );
  return (
    <div className="folder-list user-post-list">
      <table className="table">
        {renderHeader()}
        {renderBody()}
      </table>
    </div>
  );
};

export default PostTable;
